export default "__VITE_ASSET__Ux73dnRP__"